export const routesReceipt = [
  {
    path: "/ai-plaka",
    name: "aiplaka",
    component: () => import("@/views/aiplaka/index.vue"),
    meta: {
      public: false,
      title: "AI Plaka",
      yetki: { k: [], a: true },
    },
  },
]
